import http from './http'
let showLoading = false

//报警规则列表
export const getPoliceList = data => {
	return http({ method: 'post', url: '/heating/api/police/list', data })
}

//新增报警规则
export const getInsertPolice = data => {
	return http({ method: 'post', url: '/heating/api/police/insertPolice', data })
}

//修改报警规则
export const getUpdatePolice = data => {
	return http({ method: 'put', url: '/heating/api/police/updatePolice', data })
}

//删除报警规则
export const getPoliceDel = eventIdent => {
	return http({ method: 'delete', url: `/heating/api/police/del/${eventIdent}` })
}

//报警规则详情
export const getPoliceDetails = eventIdent => {
	return http({ method: 'get', url: `/heating/api/police/details/${eventIdent}` })
}

//根据项目查询项目联系人、网点联系人
export const getPhoneByProject = data => {
	return http({ method: 'post', url: `/heating/api/police/phoneByProject`, data })
}

//历史数据
export const getPoliceHisList = data => {
	return http({ method: 'post', url: `/heating/api/police/hisList`, data, showLoading })
}

//报警历史的处理状态
export const getPoliceProcess = data => {
	return http({ method: 'post', url: `/heating/api/police/process`, data })
}

//规则状态的启用禁用
export const getPoliceState = (eventIdent, state) => {
	return http({ method: 'get', url: `/heating/api/police/state/${eventIdent}/${state}` })
}


//当天报警总数
export const getPoliceAlarmToday = () => {
	return http({ method: 'get', url: `/heating/api/police/alarmToday` })
}

//当天处理报警数
export const getPoliceAlarmProcessToday = () => {
	return http({ method: 'get', url: `/heating/api/police/alarmProcessToday` })
}

//报警已读
export const getPoliceRead = eventHistoryIdent => {
	return http({ method: 'get', url: `/heating/api/police/read/${eventHistoryIdent}` })
}

//根据设备标识查询所属项目
export const getProByDeviceIdent = (data) => {
	return http({ method: 'post', url: `/heating/api/police/proByDeviceIdent`,data,showLoading })
}

//报警历史数据导出
export const getBjHisExport = data => {
	return http({ method: 'post', url: '/heating/api/police/bjHisExport', data, imgUrl: true })
}
